module.exports = __webpack_public_path__ + "static/media/avatar10.44583a8f.png";